import { characterAbility, characterName } from "../characters.js";
import { characterPortrait } from "../characterArt.js";
import type { RenderPlayer } from "../stateReplayer.js";

export interface PlayerPanelProps {
  player: RenderPlayer;
  showHidden: boolean;
  active: boolean;
  winner: boolean;
}

export function PlayerPanel({
  player,
  showHidden,
  active,
  winner,
}: PlayerPanelProps) {
  return (
    <div
      className="player-panel"
      style={{
        borderColor: active ? "#f9d64a" : winner ? "#4aae44" : "#333",
        borderWidth: active || winner ? 2 : 1,
      }}
    >
      <div className="player-panel__header">
        <span
          className="player-panel__swatch"
          style={{ background: colorFor(player.color) }}
        />
        <span className="player-panel__name">
          {player.id}
          {winner && " · WINNER"}
          {active && !winner && " · active"}
        </span>
      </div>
      {player.character_id && (
        <div
          className="player-panel__character"
          title={characterAbility(player.character_id) ?? ""}
        >
          <span
            className="player-panel__portrait"
            style={{
              background: characterPortrait(player.character_id).color,
              color: characterPortrait(player.character_id).accent,
            }}
            aria-hidden="true"
          >
            {characterPortrait(player.character_id).emoji}
          </span>
          <span className="player-panel__character-text">
            <strong>{characterName(player.character_id)}</strong>
            <span className="player-panel__ability">
              {characterAbility(player.character_id)}
            </span>
          </span>
        </div>
      )}
      <div className="player-panel__row">
        <div>Position</div>
        <div>
          ({player.pirate.position.q},{player.pirate.position.r})
          {player.pirate.in_boat && " ⛵"}
        </div>
      </div>
      <div className="player-panel__row">
        <div>Boat</div>
        <div>
          ({player.boat_position.q},{player.boat_position.r})
        </div>
      </div>
      <div className="player-panel__row">
        <div>Inventory ({player.inventory.length})</div>
        <div className="player-panel__inventory">
          {player.inventory.length === 0
            ? "—"
            : player.inventory.map((item, i) => (
                <span
                  key={i}
                  className={`inv-chip ${item === "treasure" ? "inv-chip--treasure" : ""}`}
                >
                  {item}
                </span>
              ))}
        </div>
      </div>
      <div className="player-panel__row">
        <div>Stash markers</div>
        <div>{player.stashes.map((s) => s.cell_key).join(" · ") || "—"}</div>
      </div>
      {showHidden && (
        <div className="player-panel__row">
          <div>Known landmark</div>
          <div>{player.known_treasure_landmark_id ?? "—"}</div>
        </div>
      )}
    </div>
  );
}

function colorFor(color: string): string {
  const map: Record<string, string> = {
    red: "#e6533a",
    pink: "#e58ba9",
    blue: "#3f83e6",
    purple: "#8a4ee6",
    white: "#f5f5f5",
    black: "#232323",
    green: "#4aae44",
  };
  return map[color] ?? "#666";
}
